@file:JvmName("ModifierExt")

package com.kinoshazam.uiKit.extension

import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.Indication
import androidx.compose.foundation.clickable
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.WindowInsetsSides
import androidx.compose.foundation.layout.exclude
import androidx.compose.foundation.layout.ime
import androidx.compose.foundation.layout.navigationBars
import androidx.compose.foundation.layout.only
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.composed
import androidx.compose.ui.draw.drawWithContent
import androidx.compose.ui.graphics.BlendMode
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.CompositingStrategy
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.layout.layout
import androidx.compose.ui.unit.Dp
import kotlin.jvm.JvmName

@OptIn(ExperimentalFoundationApi::class)
fun Modifier.applyClickableIfNeeded(
    isClickable: Boolean,
    enabled: Boolean = true,
    onLongClick: (() -> Unit)? = null,
    onClick: () -> Unit,
): Modifier {
    return if (isClickable) {
        combinedClickable(
            onClick = onClick,
            onLongClick = onLongClick,
            enabled = enabled,
        )
    } else {
        this
    }
}

@Composable
fun Modifier.uiKitImePadding(): Modifier {
    return windowInsetsPadding(
        WindowInsets.ime
            .only(WindowInsetsSides.Bottom)
            .exclude(WindowInsets.navigationBars)
    )
}

@Composable
fun Modifier.disable(): Modifier {
    return clickable(
        indication = null,
        interactionSource = remember { MutableInteractionSource() }
    ) { Unit }
}

@OptIn(ExperimentalFoundationApi::class)
fun Modifier.applyClickableIfNeeded(
    isClickable: Boolean,
    indication: Indication?,
    enabled: Boolean = true,
    onLongClick: (() -> Unit)? = null,
    onClick: () -> Unit,
): Modifier {
    return if (isClickable) {
        composed {
            combinedClickable(
                onClick = onClick,
                onLongClick = onLongClick,
                enabled = enabled,
                indication = indication,
                interactionSource = remember { MutableInteractionSource() },
            )
        }
    } else {
        this
    }
}

fun Modifier.thenNullable(other: Modifier?): Modifier {
    return other?.let {
        then(other)
    } ?: this
}

fun Modifier.thenIf(other: Modifier, condition: Boolean): Modifier {
    return if (condition) then(other) else this
}

fun Modifier.tint(tintColor: Color): Modifier {
    return graphicsLayer(compositingStrategy = CompositingStrategy.Offscreen)
        .drawWithContent {
            drawContent()
            drawRect(
                color = tintColor,
                size = size,
                blendMode = BlendMode.SrcIn,
            )
        }
}

fun Modifier.ignoreParentHorizontalPadding(horizontal: Dp): Modifier {
    return layout { measurable, constraints ->
        val overridenWidth = constraints.maxWidth + 2 * horizontal.roundToPx()
        val placeable = measurable.measure(constraints.copy(maxWidth = overridenWidth))
        layout(placeable.width, placeable.height) {
            placeable.place(0, 0)
        }
    }
}
